import { api } from "@/lib/api";

let p = null;
export function presalesStatus() {
  if (!p) p = api.get("/presales/status").then((r) => r.data).catch(() => ({ enabled: false, visible: false }));
  return p;
}
export const PRESALES_NAV = [["My calls", "/presales/my-calls"], ["Team", "/presales/team"], ["Settings", "/presales/settings"], ["Dialling", "/presales"], ["Analytics", "/presales/analytics"], ["Cold-call script", "/presales/script"]];
export const presalesNavFor = (s) => PRESALES_NAV.filter(([l]) => (l === "Team" || l === "Settings" || l === "Dialling" || l === "Analytics") ? s?.manager : true);
export const fmtINR = (v) => (v == null ? "—" : "₹" + Math.round(v).toLocaleString("en-IN"));
